(function () {
  document.querySelectorAll('.pt-benefit-policy').forEach(function (root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    var button = root.querySelector('[popovertarget]');
    var panel = root.querySelector('[popover]');
    if (!panel.showPopover) return;
    function position() {
      var anchor = button.getBoundingClientRect();
      var width = panel.offsetWidth;
      var height = panel.offsetHeight;
      var gap = 8;
      var edge = 12;
      var left = Math.max(edge, Math.min(anchor.right - width, window.innerWidth - width - edge));
      var top = anchor.bottom + gap;
      if (top + height > window.innerHeight - edge) top = anchor.top - height - gap;
      panel.style.left = left + 'px';
      panel.style.top = Math.max(edge, top) + 'px';
    }
    function show() {
      if (!panel.matches(':popover-open')) panel.showPopover();
      position();
    }
    button.addEventListener('focus', function () { if (button.matches(':focus-visible')) show(); });
    button.addEventListener('click', function (event) { event.preventDefault(); show(); });
    button.addEventListener('pointerenter', function (event) { if (event.pointerType === 'mouse') show(); });
    root.addEventListener('pointerleave', function (event) {
      if (event.pointerType === 'mouse' && !root.contains(document.activeElement) && panel.matches(':popover-open')) panel.hidePopover();
    });
    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget) && panel.matches(':popover-open')) panel.hidePopover();
    });
    panel.addEventListener('toggle', function () { button.setAttribute('aria-expanded', String(panel.matches(':popover-open'))); });
    window.addEventListener('resize', function () { if (panel.matches(':popover-open')) position(); });
    window.addEventListener('scroll', function () { if (panel.matches(':popover-open')) position(); }, true);
  });
}());
